<template>
  <div class="gallery">
    <ul>
      <li v-for="(item, index) in gallery" :key="item.id"
          @click="$emit('change-gallery-item', item, index)">
        <img :src="item.src"
             :class="{'is-active': current===index }"
             alt=""
             @contextmenu.prevent @drag.prevent @dragstart.prevent
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "GalleryThumbs",

  props: {
    gallery: {},
    current: 0
  },

  data() {
    return {};
  },

  computed: {},

  methods: {}
}
</script>

<style lang="scss" scoped>
.gallery {
  position: absolute;
  max-height: 100%;
  overflow: auto;

  @media all and (max-width: 768px) {
    top: 110%;
    width: 100%;
  }

  @media all and (min-width: 768px) {
    left: calc(100% + 1rem);
    top: 0;
    height: 100%;
    width: var(--mgt-gallery-thumbs-size);
    padding-right: 1rem;
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    //box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  }

  &::-webkit-scrollbar-thumb {
    background-color: darkgrey;
  }
}

.gallery ul {
  @media all and (max-width: 768px) {
    white-space: nowrap;
    li {
      display: inline-block;
      vertical-align: middle;
      margin: 0 1rem;
    }
  }
  @media all and (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: column;
  }
}

.gallery li {
  margin-bottom: 1rem;
  cursor: pointer;
  background: #444;
  overflow: hidden;
  height: var(--mgt-gallery-thumbs-size);

  img {
    transition: all 0.3s ease-in-out;
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: grayscale(1);
  }
}

.gallery::v-deep(li:hover img),
.gallery::v-deep(li img.is-active) {
  opacity: 1;
  transform: scale(1.2) rotate(5deg);
  filter: grayscale(0);
}
</style>